import React, { useEffect } from 'react';
import { Col, Row, Card } from 'react-bootstrap';

import ConnectStripe from './ConnectStripe';

import WODPaymentsList from './WODPaymentsList';
import WODProductTable from './WODProductTable';
import WODAthleteTable from './WODAthleteTable';
import PaymentService from './PaymentService';

const PaymentLandingPage = () => {
  const [showStripeConnect, setShowStripeConnect] = React.useState(false);
  const [wodGym, setWodGym] = React.useState(null);
  useEffect(() => {
    // Check if the user has connected their Stripe account
    PaymentService.retrieveGymDetails().then(data => {
      console.log('Gym Details:', data);
      setWodGym(data);
      if (!data.stripeAccountId) {
        setShowStripeConnect(true);
      }
    });
  }, []);

  return (
    <>

        <Row className="g-3 mb-3">

          <Col>
            {showStripeConnect && (<ConnectStripe />)}
            {!showStripeConnect && (
              <Card>
                <Card.Body>
                  <h5>Stripe Connected</h5>
                  <p>Your Stripe account is connected. You can now manage your payments and memberships.</p>
                  <p><b>Stripe Account ID:</b> {wodGym?.stripeAccountId}</p>
                </Card.Body>
              </Card>
            )}
          </Col>
        </Row>


      {!showStripeConnect &&(<WODProductTable />)}
      <br/>
      {!showStripeConnect &&(<WODAthleteTable />)}
      <br/>
      <WODPaymentsList />  
      <Row className="g-3">
        <Col xxl={8}>
        </Col>
        <Col xxl={4}>
        </Col>
      </Row>
    </>
  );
};

export default PaymentLandingPage;